class BeforeAfterCompare extends HTMLElement {
  constructor() {
    super();

    this.range = this.querySelector('[data-before-after-compare-range]');
    this.slider = this.querySelector('[data-before-after-compare-slider]');
    this.thumb = this.querySelector('[data-before-after-compare-thumb]');
    this.overlay = this.querySelector('[data-before-after-compare-overlay]');
  }

  connectedCallback() {
    if ('ontouchstart' in window === false) {
      this.range.addEventListener('mouseup', this.setSliderstate.bind(this));
      this.range.addEventListener('mousedown', this.moveSliderThumb.bind(this));
    }

    this.range.addEventListener('input', this.moveSliderRange.bind(this));
    this.range.addEventListener('change', this.moveSliderRange.bind(this));
  }

  disconnectedCallback() {
    if ('ontouchstart' in window === false) {
      this.range.removeEventListener('mouseup', this.setSliderstate.bind(this));
      this.range.removeEventListener('mousedown', this.moveSliderThumb.bind(this));
    }

    this.range.removeEventListener('input', this.moveSliderRange.bind(this));
    this.range.removeEventListener('change', this.moveSliderRange.bind(this));
  }

  setSliderstate(e) {
    if (e.type === 'input') {
      this.range.classList.add('before-after-compare__range--active');
      return;
    }

    this.range.classList.remove('before-after-compare__range--active');
    this.removeEventListener('mousemove', this.moveSliderThumb.bind(this));
  }

  moveSliderThumb(e) {
    if (this.range.classList.contains('before-after-compare__range--active')) {
      let position = e.layerY - 20;

      if (e.layerY <= this.range.offsetTop) {
        position = -20;
      }

      if (e.layerY >= this.range.offsetHeight) {
        position = this.range.offsetHeight - 20;
      }

      this.thumb.style.top = `${position}px`;
    }
  }

  moveSliderRange(e) {
    const value = e.target.value;

    this.slider.style.left = `${value}%`;
    this.overlay.style.width = `${value}%`;

    this.addEventListener('mousemove', this.moveSliderThumb.bind(this));
    this.setSliderstate(e);
  }
}

if (!customElements.get('before-after-compare')) {
  customElements.define('before-after-compare', BeforeAfterCompare);
}
